import { Injectable } from '@angular/core';
import { State, StateToken, Action, StateContext } from '@ngxs/store';
import { SetToolSearch } from './tool-search-action';

export const TOOL_SEARCH_TOKEN = new StateToken<any>('ToolSearch');

@State({
    name: TOOL_SEARCH_TOKEN,
    defaults: []
})
@Injectable()
export class ToolSearchState {
    @Action(SetToolSearch)
    set(ctx: StateContext<any>, action: SetToolSearch) {
        ctx.setState(action.data);
    }
}
